







































import { defineComponent, onMounted, ref } from '@vue/composition-api';

import { getMe } from '@/api';
import useAuth from '@/use/useAuth';

const List = defineComponent({
  setup(props, { root }) {
    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }

    const me = ref(root.$store.getters.me);

    return {
      me,
      hasPermission,
      openToS: () => {
        window.open('/#/terms-of-service');
      },
    };
  },
});

export default List;
